/**
 * HomeGroupWA Homepage JS Include
 *
 * @author Strange Animals <info@strangeanimals.com.au>
 */

$(document).ready(function($) {
    // Promotion Slider

    $('.promotion-slider').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        infinite: false,
        autoplay: false,
        pauseOnHover: false,
        lazyLoad: 'ondemand',
        arrows: true,
        nextArrow: $('.promotion-next'),
        prevArrow: $('.promotion-prev')
    });
});
